module.exports = __webpack_public_path__ + "static/media/team.56c485a0.svg";